import GenericUtils from "../../utils/GenericUtils";
import SelectOption from "../SelectOption";

export enum StatusSubprocess {
    CANCELED = "CANCELED",
    PENDING = "PENDING",
    DONE = "DONE",
    WAITING_APPROVAL = "WAITING_APPROVAL",
}

export const StatusSubprocessLabel = new Map<StatusSubprocess, string>([
    [StatusSubprocess.CANCELED, "Cancelado"],
    [StatusSubprocess.PENDING, "Aguardando Justificativa"],
    [StatusSubprocess.DONE, "Finalizado"],
    [StatusSubprocess.WAITING_APPROVAL, "Aguardando Aprovação"],
]);

export const getOptionsStatusSubprocess = () => {
    const enumList = Array.from(StatusSubprocessLabel).map((item: any) => {
        return GenericUtils.impl<SelectOption>({
            value: String(item.at(0)),
            label: item.at(1),
        });
    });

    return enumList?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getLabelStatusSubprocessEnum = (
    value: StatusSubprocess | null
) => {
    if (!value) return "";

    return StatusSubprocessLabel.get(value);
};
